export const currencyTrans = {
	DKK: "kr.",
	EUR: "€",
	USD: "$"
}